import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { logProductionReadiness } from '@/utils/productionChecks'

// Run production readiness checks
logProductionReadiness();

createRoot(document.getElementById("root")!).render(<App />);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
